import { batchActions } from './utils';
import { setData } from './data';
import { Thunk } from '../types';

export const updateDateRange = (
  startDate: string,
  endDate: string,
  label: string,
): Thunk => async dispatch => {
  const key = 'dateRange';

  const data = {
    startDate,
    endDate,
    label,
  };
  dispatch(batchActions([setData({ [key]: data })], 'audience/UPDATE_DATE_RANGE_SUCCESS'));
};
